import { DateTime } from "luxon"

import { DateRangeType } from "../component/DateRangePicker"

export const formatTimestampBetween = (timeNowUTC: DateTime, periodDays = 5): [number, number] => {
    const timePeriodDaysAgo = timeNowUTC.minus({ days: periodDays })
    return [Math.round(timePeriodDaysAgo.toSeconds()), Math.round(timeNowUTC.toSeconds())]
}
export const formatDateRangeToSecond = (dateRange: DateRangeType): [number, number] => {
    let [startDate, endDate] = dateRange
    if (!startDate) {
        startDate = new Date()
    }
    if (!endDate) {
        endDate = new Date()
    }

    const beginOfStartDate = DateTime.fromJSDate(startDate).startOf("day")
    const endOfEndDateTo = DateTime.fromJSDate(endDate).endOf("day")
    const startDateToSeconds = beginOfStartDate.toUTC().toSeconds()
    const endDateToSeconds = endOfEndDateTo.toUTC().toSeconds()
    return [Math.round(startDateToSeconds), Math.round(endDateToSeconds)]
}
